import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NotificationPreferences } from "@/components/settings/NotificationPreferences";

/** Account-level opt-out stays reachable without onboarding or a subscription. */
export default function AccountNotifications() {
  const { t } = useTranslation();
  return <main className="min-h-dvh bg-cream px-4 py-8 sm:px-6">
    <div className="mx-auto max-w-2xl space-y-5">
      <nav className="flex flex-wrap gap-4 text-sm text-amber-dark" aria-label={t("account_data.navigation")}>
        <Link to="/settings" className="underline">{t("settings.title")}</Link>
        <Link to="/pricing" className="underline">{t("account_data.subscription")}</Link>
        <Link to="/account/data" className="underline">{t("account_data.title")}</Link>
      </nav>
      <NotificationPreferences />
    </div>
  </main>;
}
